export default (app) => {
  const $inject = ['$httpProvider', 'APP_CONFIG'];

  const HttpProviderConfig = function ($httpProvider, APP_CONFIG) {
    $httpProvider.defaults.useXDomain = true;

    $httpProvider.defaults.headers.common['Content-Type'] = 'application/json; charset=utf-8';

    $httpProvider.defaults.headers.common['X-api-version'] = APP_CONFIG.api.version;

    delete $httpProvider.defaults.headers.common['X-Requested-With'];

    $httpProvider.interceptors.push('requestInterceptor');
  };

  HttpProviderConfig.$inject = $inject;

  return HttpProviderConfig;
};



// WEBPACK FOOTER //
// ./src/config/httpProviderConfig.js